import { Box, Grid } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getStudyAbroadStatusAsync } from "src/redux/services/studyAbroadServices";
import ProgressChart from "./ProgressChart";
import StudyAbroadCard from "./StudyAbroadCard";

const AdmissionDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { dashboardData, isLoading } = useSelector(
    (state) => state.studyAbroad,
  );

  useEffect(() => {
    dispatch(getStudyAbroadStatusAsync());
  }, [dispatch]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Completed":
        return "#4ADF86";
      case "In Progress":
        return "#FF914D";
      case "Not Applicable":
        return "#333333";
      case "Awaiting Action":
        return "rgb(61, 144, 160)";
      default:
        return "#333333";
    }
  };

  const data = [
    {
      title: "PERSONALIZED MENTORING",
      subtitle: "Information and usages of your current plan",
      navigateTo:
        "/dashboard/studyabroad?category=personalized&status=counselling",
      statuses: [
        {
          label: "Counselling",
          status: isLoading ? "loading..." : dashboardData?.counselling,
        },
        {
          label: "Profile Building",
          status: isLoading ? "loading..." : dashboardData?.profileBuilding,
        },
        {
          label: "Psychometric Test",
          status: isLoading ? "loading..." : dashboardData?.psychometric,
        },
      ].map((item) => ({ ...item, color: getStatusColor(item.status) })),
    },
    {
      title: "Career Mapping",
      subtitle: "Information and usages of your current plan",
      navigateTo: "/dashboard/studyabroad?category=career&status=countries",
      statuses: [
        {
          label: "Countries",
          status: isLoading ? "loading..." : dashboardData?.countries,
        },
        {
          label: "Courses",
          status: isLoading ? "loading..." : dashboardData?.courses,
        },
        {
          label: "Universities",
          status: isLoading ? "loading..." : dashboardData?.universities,
        },
      ].map((item) => ({ ...item, color: getStatusColor(item.status) })),
    },
    {
      title: "Admission Service",
      subtitle: "Information and usages of your current plan",
      navigateTo: "/dashboard/studyabroad?category=admission&status=test",
      statuses: [
        {
          label: "Test Preparation",
          status: isLoading ? "loading..." : dashboardData?.testPreparation,
        },
        {
          label: "LORs/ essays/ SOPs",
          status: isLoading ? "loading..." : dashboardData?.lorSopEssay,
        },
        {
          label: "Scholarship",
          status: isLoading ? "loading..." : dashboardData?.application,
        },
      ].map((item) => ({ ...item, color: getStatusColor(item.status) })),
    },
    {
      title: "Post Enrollment Support",
      subtitle: "Information and usages of your current plan",
      navigateTo: "/dashboard/studyabroad?category=post&status=education",
      statuses: [
        {
          label: "Education Loan",
          status: isLoading
            ? "loading..."
            : dashboardData?.educationLoanSupport,
        },
        {
          label: "VISA/IMMIGRATION/TRAVEL & FOREX",
          status: isLoading
            ? "loading..."
            : dashboardData?.visaSupportAndTravel,
        },
        {
          label: "ACCOMMODATION",
          status: isLoading
            ? "loading..."
            : dashboardData?.accommodationSupport,
        },
      ].map((item) => ({ ...item, color: getStatusColor(item.status) })),
    },
  ];

  return (
    <Box sx={{ margin: "40px 20px", display: "flex", flexDirection: "column" }}>
      <ProgressChart chartData={dashboardData} isLoading={isLoading} />

      <Box marginTop={"20px"}>
        <Grid container spacing={2}>
          {data.map((item, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <StudyAbroadCard
                data={item}
                onClick={() => navigate(item.navigateTo)}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default AdmissionDashboard;
